import store from '../../store';
import CartHelpersMixin from '../../mixins/CartHelpersMixin';
import ProductHelpersMixin from '../../mixins/ProductHelpersMixin';

const FREE_SHIPPING_THRESHOLD = 500;
const FREE_SHIPPING_COST = 49;

export default {
    mixins: [
        CartHelpersMixin,
        ProductHelpersMixin,
    ],

    data() {
        return {
            shippingMethodName: null,
            crossSellProducts: [],
        };
    },

    computed: {
        hasAnyCrossSellProduct() {
            return this.crossSellProducts.length !== 0;
        },
        cartSubTotalAmount() {
            if (
                !this.cart ||
                !this.cart.subTotalOrginal ||
                !this.cart.subTotalOrginal.inCurrentCurrency
            ) {
                return 0;
            }

            let amount = Number(this.cart.subTotalOrginal.inCurrentCurrency.amount);

            return Number.isNaN(amount) ? 0 : amount;
        },
        freeShippingRemaining() {
            return Math.max(0, FREE_SHIPPING_THRESHOLD - this.cartSubTotalAmount);
        },
        freeShippingProgress() {
            if (this.cartSubTotalAmount <= 0) {
                return 0;
            }

            return Math.min(
                100,
                (this.cartSubTotalAmount / FREE_SHIPPING_THRESHOLD) * 100
            );
        },
        freeShippingRemainingFormatted() {
            return this.formatCurrencyValue(this.freeShippingRemaining);
        },
        freeShippingCostFormatted() {
            if (this.freeShippingRemaining > 0) {
                return `${this.formatCurrencyValue(FREE_SHIPPING_COST)} €`;
            }

            if (
                this.cart &&
                this.cart.shippingCost &&
                this.cart.shippingCost.inCurrentCurrency
            ) {
                return this.cart.shippingCost.inCurrentCurrency.formatted;
            }

            return `${this.formatCurrencyValue(0)} €`;
        },
    },

    mounted() {
      // if(localStorage.queryParams){
      //   localStorage.removeItem("queryParams");
      // }
    },

    created() {
        this.$nextTick(() => {
            if (store.state.cart.shippingMethodName) {
                this.changeShippingMethod(store.state.cart.shippingMethodName);
            } else {
                this.updateShippingMethod(this.firstShippingMethod);
            }

            this.fetchCrossSellProducts();
        });
    },

    methods: {
        formatCurrencyValue(value) {
            let amount = Number(value);

            if (Number.isNaN(amount)) {
                amount = 0;
            }

            return amount.toLocaleString('de-DE', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            });
        },
        optionValues(option) {
            let values = [];

            for (let value of option.values) {
                values.push(value.label);
            }

            return values.join(', ');
        },

        updateQuantity(cartItem, qty) {
            if (parseInt(qty) < 1 || this.exceedsMaxStock(cartItem, qty)) {
                return;
            }
            if (isNaN(qty)) {
                qty = 1;
            }
            this.loadingOrderSummary = true;
            cartItem.qty = qty;

            $.ajax({
                method: 'PUT',
                url: route('cart.items.update', { cartItemId: cartItem.id }),
                data: { qty: qty || 1 },
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        exceedsMaxStock(cartItem, qty) {
            return parseInt(cartItem.product.qty) < parseInt(qty);
        },

        remove(cartItem) {
            this.loadingOrderSummary = true;

            store.removeCartItem(cartItem);

            if (store.cartIsEmpty()) {
                this.crossSellProducts = [];
            }

            $.ajax({
                method: 'DELETE',
                url: route('cart.items.destroy', { cartItemId: cartItem.id }),
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        clearCart() {
            store.clearCart();

            if (store.cartIsEmpty()) {
                this.crossSellProducts = [];
            }

            $.ajax({
                method: 'POST',
                url: route('cart.clear.store'),
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            });
        },

        changeShippingMethod(shippingMethodName) {
            this.shippingMethodName = shippingMethodName;
        },

        fetchCrossSellProducts() {
            $.ajax({
                method: 'GET',
                url: route('cart.cross_sell_products.index'),
            }).then((crossSellProducts) => {
                this.crossSellProducts = crossSellProducts;
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            });
        },
    },
};
